export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_RESULTS(state, data) {
    state.products = data || []
  },

  SET_PRODUCT_DETAILS(state, data) {
    state.productDetails = data
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
  SET_SEARCH_REFINEMENTS(state, data) {
    state.searchRefinements = data
  },
  SET_MATCHING_PRODUCT_COUNT(state, data) {
    state.matchingProductCount = data
  },
  RESET_FILTERS(state) {
    state.filters = {
      keywords: [],
      pageSize: 10,
      sortKey: 'RELEVANCE',
      searchWithin: '',
      upc: '',
      shippingPostalCode: '',
      selected: [],
      single: {},
      pageNumber: 0
    },
    state.searchRefinements = []
    state.matchingProductCount = 0
    state.pagination = { total: 0, current_page: 1, last_page: 1, numberOfPages: 0 }
  },

  SET_PAGINATION(state, data) {
    state.pagination = {
      total: data.total || 0,
      current_page: data.current_page || 1,
      last_page: data.last_page || 1,
      numberOfPages: data.numberOfPages
    }
  },

  RESET_KEYWORDS(state) {
    state.filters.keywords = []
  },

  ADD_KEYWORD(state, keyword) {
    state.filters.keywords.push(keyword)
    state.filters.searchWithin = ''
  },

  REMOVE_KEYWORD(state, index) {
    state.filters.keywords.splice(index, 1)
  },
  SET_GLOBAL_SEARCH(state, data) {
    state.globalSearch = data
  },
  SET_SHOW_DUMMY_DATA(state, data) {
    state.showDummyData = data
  }
}